import dayjs from 'dayjs';

export function formatDate(date, format = 'DD-MM-YYYY') {
    return dayjs(date).format(format);
}

export function formatNewDate(date) {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const vnDate = new Date(date);
    return vnDate.toLocaleDateString("vi-VN", {
        timeZone: "Asia/Ho_Chi_Minh",
    });
}

export function getTime(date) {
    const vnDate = new Date(date);

    return vnDate.toLocaleTimeString("vi-VN", {
        timeZone: "Asia/Ho_Chi_Minh",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
    });
}
